import { render, staticRenderFns } from "./IntegrationTags.vue?vue&type=template&id=a2e5e9de&"
import script from "./IntegrationTags.vue?vue&type=script&lang=js&"
export * from "./IntegrationTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports